const COOKIE_NAME = 'logged_in';
const COOKIE_DOMAIN = 'organicelectronics.io';
const MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

/**
 * Writes the signed-in state to a cookie shared across the organicelectronics.io
 * subdomains, so other sites on that domain can tell whether the user is logged in.
 * Other hosts (localhost, *.web.app) would reject that domain, so the cookie stays
 * host-only there.
 */
export function writeLoggedInCookie(loggedIn: boolean): void {
    const { hostname, protocol } = window.location;
    const onSiteDomain = hostname === COOKIE_DOMAIN || hostname.endsWith(`.${COOKIE_DOMAIN}`);

    document.cookie = [
        `${COOKIE_NAME}=${loggedIn}`,
        onSiteDomain && `domain=.${COOKIE_DOMAIN}`,
        'path=/',
        `max-age=${MAX_AGE_SECONDS}`,
        'SameSite=Lax',
        protocol === 'https:' && 'Secure',
    ].filter(Boolean).join('; ');
}
